/**
 * @deprecated
 * This function is solely used for the purpose of scaling SVG paths to bakedRules.unit. Other
 * non-SVG scenarios that use bakedRules.unit are converted to the correct units when the bakedRules
 * are parsed/evaluated.
 *
 * Also, obviously, this function is currently not implemented and returns a no-op value.
 *
 * See the following diff for the original intent behind this function:
 * https://github.com/buildwithflux/flux-app/blame/1a817d7a86db19a32c7887d189b350b7efeb16a2/frontend/src/components/pages/document/components/editor/components/pcb_editor/components/pcb_editor_canvas/helpers/shapes/helpers/scaleShapeBasedOnUnitRule.ts#L7
 */
export function scaleFromUnit(_unit) {
    // overwritten for this PR
    return 1;
}
//# sourceMappingURL=scaleShapeBasedOnUnitRule.js.map